// @flow
import React from 'react';
import styler from 'react-styling';

const style = styler `
    Tag
      border: 1px solid #C0D1F4
      background-color: #EAEFFA
      margin-right: 5px
      margin-bottom: 5px
      padding: 2px 5px
      display: inline-block
      vertical-align: middle
      color: #497BEB
      font-size: 12px
  `;

const Tags = (props: { tags: string[] }) => {
  const tags = props.tags.map((value, index) => <span style={style.Tag} key={index}>{value}</span>);
  return (
    <div>
      {tags}
    </div>
  );
};

export default Tags;



// WEBPACK FOOTER //
// ./src/js/Components/Tags.js